/* import __COLOCATED_TEMPLATE__ from './application-parameters.hbs'; */
import Component from '@glimmer/component';

export default class ApplicationParameters extends Component {
  get calibrationFeatureEnabled() {
    return window.toggledFeatures.calibration;
  }
}
